import type { FC } from 'react';
import { Button, Text, Link, Heading } from '@livechat/design-system-react-components';

import * as styles from './styles';

type Props = {
  user: string;
};

export const AlreadySignedIn: FC<Props> = ({ user }) => (
  <div>
    <div css={styles.alreadySignedContainer}>
      <Heading size="lg" css={styles.title}>
        You’re already logged in
      </Heading>
      <Button
        kind="primary"
        size="large"
        onClick={() => {
          window.location.href = import.meta.env.VITE_APP_LC_APP_URL;
        }}
        css={styles.alreadySignedInButton}
      >
        Continue as {user}
      </Button>
      <Text>
        <Link bold={false} href="/">
          Log in with another account
        </Link>
      </Text>
    </div>
  </div>
);
